// ABOUTME: Route for /facility/lines/$lineId.
// ABOUTME: Loader prefetches shift templates and documents on hover.

import LineDetailPage from "@/components/facility/LineDetailPage";
import { authedFetch } from "@/lib/authedFetch";
import { queryClient } from "@/lib/queryClient";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/facility/lines/$lineId")({
  loader: ({ params: { lineId } }) => {
    queryClient.ensureQueryData({
      queryKey: ["shift-templates", lineId],
      queryFn: () => authedFetch(`/api/lines/${lineId}/shift-templates`),
      staleTime: 30_000,
    });
    queryClient.ensureQueryData({
      queryKey: ["line-documents", lineId],
      queryFn: () => authedFetch(`/api/lines/${lineId}/documents`),
      staleTime: 30_000,
    });
  },
  component: LineDetailPage,
});
